<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">机器人设置</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs v-model="type" @tab-click="handleTypeChange" type="card">
        <el-tab-pane
          :label="names.mirrorBargain"
          name="mirrorBargain"
        ></el-tab-pane>
        <el-tab-pane :label="names.mirror" name="mirror"></el-tab-pane>
      </el-tabs>
      <div class="total-btn">
        <h3>{{ names[type] }}总开关:</h3>

        <el-switch
          active-color="#13ce66"
          @change="onSwitch({ type, button: !totalButton })"
          :value="totalButton && totalButton"
        ></el-switch>
      </div>

      <el-divider></el-divider>
      <el-table height="calc(100vh - 360px)" :data="currentList">
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="交易对开关">
          <template slot-scope="scope">
            <el-switch
              active-color="#13ce66"
              @change="
                onOneSwitch({
                  pair: scope.row.pair,
                  type,
                  button: !scope.row.button,
                })
              "
              :value="scope.row.button"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="自动操盘开关" v-if="type === 'mirror'">
          <template slot-scope="scope">
            <el-switch
              active-color="#13ce66"
              @change="
                setAutos({
                  pair: scope.row.pair,
                  type,
                  button: !scope.row.autoButton,
                })
              "
              :value="scope.row.autoButton"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="数量系数"
          prop="amountScore"
          v-if="type === 'mirrorBargain'"
        ></el-table-column>
        <el-table-column
          label="价格系数"
          prop="valvePrice"
          v-if="type === 'mirrorBargain'"
        ></el-table-column>
        <el-table-column
          label="机器人ID"
          prop="robotUserId"
          v-if="type === 'mirror'"
        ></el-table-column>
        <el-table-column
          label="买单数量系数"
          prop="buyAmountScore"
          v-if="type === 'mirror'"
        ></el-table-column>
        <el-table-column
          label="买单价格系数"
          prop="buyPriceScore"
          v-if="type === 'mirror'"
        ></el-table-column>
        <el-table-column
          label="卖单数量系数"
          prop="sellAmountScore"
          v-if="type === 'mirror'"
        ></el-table-column>
        <el-table-column
          label="卖单价格系数"
          prop="sellPriceScore"
          v-if="type === 'mirror'"
        ></el-table-column>
        <el-table-column
          label="初始余额"
          prop="initBalance"
          v-if="type === 'mirror'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.initBalance || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="初始镜像系数"
          prop="original"
          v-if="type === 'mirror'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.original || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="价格上下限系数"
          prop="cof"
          v-if="type === 'mirror'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cof || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="管理者操盘开关" v-if="type === 'mirror'">
          <template slot-scope="scope">
            <el-switch
              active-color="#13ce66"
              @change="
                setAdmins({
                  pair: scope.row.pair,
                  type,
                  button: !scope.row.operateButton,
                })
              "
              :value="scope.row.operateButton"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="option">
          <template slot-scope="scope">
            <base-set :val="scope.row" :type="type"></base-set>
            <admin-set :val="scope.row" :type="type"></admin-set>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import './store'
import { mapActions, mapState } from 'vuex'
import baseSet from './components/beseSetting'
import adminSet from './components/AdminSetting'

export default {
  name: 'robotpingSetting',
  data() {
    return {
      type: 'mirrorBargain',
      names: {
        mirrorBargain: '镜像自成交机器人',
        mirror: '镜像机器人',
      },
      searchKey: '',
    }
  },
  computed: {
    ...mapState('robotpingSetting', ['currentList', 'totalButton']),
    filteredList() {
      if (!this.searchKey) return this.currentList || []
      const keys = this.searchKey.split(/\s+/)
      return (
        this.currentList &&
        this.currentList.filter((item) => {
          return (
            item.pair &&
            keys.filter(
              (key) =>
                !key ||
                (key && item.pair.toLowerCase().includes(key.toLowerCase()))
            ).length === keys.length
          )
        })
      )
    },
  },
  methods: {
    ...mapActions('robotpingSetting', [
      'getList',
      'switchRobot',
      'setOneSwitch',
      'setTotalSwitch',
      'setAuto',
      'setadmin',
    ]),
    onSwitch(data) {
      this.setTotalSwitch(data).then(() => {
        this.getData()
      })
    },
    onOneSwitch(data) {
      this.setOneSwitch(data).then(() => {
        this.getData()
      })
    },
    setAutos(data) {
      this.setAuto(data).then(() => {
        this.getData()
      })
    },
    setAdmins(data) {
      this.setadmin(data).then(() => {
        this.getData()
      })
    },
    handleTypeChange(tab) {
      this.type = tab.name
      this.getData()
    },
    getData() {
      this.getList({ style: this.type, type: 1 })
    },
  },
  mounted() {
    this.code = null
    this.getData()
  },
  components: {
    baseSet,
    adminSet,
  },
}
</script>

<style lang="less" scoped>
.total-btn {
  padding-left: 5px;
  display: flex;
  align-items: center;
  h3 {
    margin-right: 20px;
    display: inline-block;
  }
}
.box-card-wrap {
  display: flex;
  flex-wrap: wrap;
  ::v-deep.el-card__body {
    width: 160px;
    min-width: 160px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
